<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">关联账号</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                    <el-col :span="24" class="item">
                        <div class="label">护士：{{edit_name}}</div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" class="item">
                        <div style="margin-bottom:10px"><span>账号：</span></div>
                        <el-tree
                                :data="listStaffAll"
                                show-checkbox
                                node-key="staffCode"
                                ref="tree"
                                highlight-current
                                check-on-click-node
                                :props="defaultProps">
                        </el-tree>
                    </el-col>
                </el-row>


            </div>

            <div class="modal-footer">
                <el-button type="primary" @click="confirm()">确定</el-button>
            </div>

        </div>
    </div>
</template>

<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";


    export default {
        name: 'Relation',
        data() {
            return {

                edit_businessCode:'',
                edit_name:'',
                edit_listBusinessStaffRel:[],
                nurseStaffCode:'',
                nurseCode:'',
                listStaffAll:null,
                defaultProps: {
                    children: 'listStaffAll',
                    label: 'loginName'
                },


            }
        },

        methods: {
            init(row){
                this.edit_name = row.name;
                this.nurseCode = row.nurseCode;
                this.nurseStaffCodeList = [];
                this.getListStaff();

            },
            closeSelf() {
                this.$emit("closeRelation");
            },
            getListStaff(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Nurse/IsNotBinding",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var dataAll=response.data.data;
                            dataAll.forEach(element => {
                                element.loginName='姓名：'+element.realName+' \xa0\xa0\xa0\xa0\xa0\xa0账号：'+element.loginName
                            });
                            this.listStaffAll = dataAll
                        }

                    }
                )

            },

            confirm(){
                let nodes = this.$refs.tree.getCheckedKeys(false,true);
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NurseStaffRel/Add",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        nurseCode: this.nurseCode,
                        nurseStaffCodeArr:nodes,
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            this.$emit("closeRelation");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )

            },


        }
    }


</script>


<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 300px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
